module.exports = __webpack_public_path__ + "img/2952588-12-2.940b0807.png";